/**
 * Mega Menu - Desktop Only
 * Full-width dropdown panel that appears on click of header nav links
 * Second click on an open panel navigates to the link
 */
(function() {
  'use strict';

  class MegaMenu {
    constructor() {
      this.menu = document.getElementById('mega-menu');
      this.overlay = document.getElementById('mega-menu-overlay');
      this.triggers = document.querySelectorAll('[data-mega-menu-trigger]');
      this.panels = document.querySelectorAll('[data-mega-panel]');
      this.anchor = document.querySelector('.header-hangar__shop-bar');
      this.activeTrigger = null;
      this.isOpen = false;
      this.rafId = null;

      if (!this.menu || !this.overlay) return;

      this.init();
    }

    init() {
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => this.handleTriggerClick(e, trigger));
      });

      this.overlay.addEventListener('click', () => this.close());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });

      window.addEventListener('scroll', () => this.requestPositionUpdate(), { passive: true });
      window.addEventListener('resize', () => this.requestPositionUpdate(), { passive: true });

      this.updatePosition();
      this.splitLongColumns();
    }

    /**
     * Enforces a maximum of MAX_PER_COLUMN links per sub-column: columns with
     * more links flow into multiple sub-columns (capped at 3) under the same heading.
     */
    splitLongColumns(maxPerColumn) {
      var self = this;
      this.panels.forEach(function(panel) {
        var panelMax = maxPerColumn;
        if (panelMax === undefined) {
          var allLinkItems = panel.querySelectorAll('.mega-menu__column-link-item');
          panelMax = allLinkItems.length > 24 ? 11 : 8;
        }
        var lists = panel.querySelectorAll('.mega-menu__column-links');
        lists.forEach(function(list) {
          var items = list.querySelectorAll('.mega-menu__column-link-item');
          var column = list.closest('.mega-menu__column');
          if (!column) return;
          if (items.length > panelMax) {
            var subColumns = Math.min(3, Math.ceil(items.length / panelMax));
            column.classList.add('mega-menu__column--split');
            list.style.columnCount = String(subColumns);
            column.style.maxWidth = (260 * subColumns) + 'px';
          } else {
            column.classList.remove('mega-menu__column--split');
            list.style.columnCount = '';
            column.style.maxWidth = '';
          }
          column.classList.remove('mega-menu__column--wrapped');
          self.restoreColumnHead(column, list);
        });
      });
    }

    /**
     * Moves the title and View All link into a shared header row.
     */
    buildColumnHead(column, list) {
      if (column.querySelector('.mega-menu__column-head')) return;
      var title = column.querySelector('.mega-menu__column-title');
      var viewAllItem = list.querySelector('.mega-menu__view-all-item');
      if (!title || !viewAllItem) return;
      var head = document.createElement('div');
      head.className = 'mega-menu__column-head';
      column.insertBefore(head, title);
      head.appendChild(title);
      head.appendChild(viewAllItem);
    }

    /**
     * Puts the title and View All link back into their original positions.
     */
    restoreColumnHead(column, list) {
      var head = column.querySelector('.mega-menu__column-head');
      if (!head) return;
      var title = head.querySelector('.mega-menu__column-title');
      var viewAllItem = head.querySelector('.mega-menu__view-all-item');
      if (title) column.insertBefore(title, head);
      if (viewAllItem) list.appendChild(viewAllItem);
      head.remove();
    }

    /**
     * Columns that wrapped to a row below the first get re-split at 2 links per
     * sub-column and span the full row width, making use of the free space.
     */
    splitWrappedColumns() {
      var self = this;
      var activePanel = this.menu.querySelector('.mega-menu__panel.is-active');
      if (!activePanel) return;
      var columns = activePanel.querySelectorAll('.mega-menu__column');
      if (!columns.length) return;
      var firstRowTop = Infinity;
      columns.forEach(function(col) {
        if (col.offsetTop < firstRowTop) firstRowTop = col.offsetTop;
      });
      columns.forEach(function(col) {
        if (col.offsetTop <= firstRowTop) return;
        var list = col.querySelector('.mega-menu__column-links');
        if (!list) return;
        var items = list.querySelectorAll('.mega-menu__column-link-item');
        if (items.length <= 2) return;
        col.classList.add('mega-menu__column--split');
        col.classList.add('mega-menu__column--wrapped');
        list.style.columnCount = String(Math.ceil(items.length / 2));
        col.style.maxWidth = '';
        self.buildColumnHead(col, list);
      });
    }

    /**
     * Checks if the active panel has columns wrapping to multiple rows.
     */
    hasWrapping() {
      var activePanel = this.menu.querySelector('.mega-menu__panel.is-active');
      if (!activePanel) return false;
      var columns = activePanel.querySelectorAll('.mega-menu__column');
      var tops = {};
      columns.forEach(function(col) {
        tops[col.offsetTop] = true;
      });
      return Object.keys(tops).length > 1;
    }

    /**
     * Detects the last column in each flex row and marks it so the divider
     * can be removed (avoids dangling borders when columns wrap).
     */
    markRowEnds() {
      var activePanel = this.menu.querySelector('.mega-menu__panel.is-active');
      if (!activePanel) return;
      var columns = activePanel.querySelectorAll('.mega-menu__column');
      columns.forEach(function(col) { col.classList.remove('mega-menu__column--row-end'); });
      var rows = {};
      columns.forEach(function(col) {
        var top = col.offsetTop;
        if (!rows[top]) rows[top] = [];
        rows[top].push(col);
      });
      Object.keys(rows).forEach(function(top) {
        var row = rows[top];
        if (row.length === 1) return;
        var rightmost = row[0];
        for (var i = 1; i < row.length; i++) {
          if (row[i].offsetLeft > rightmost.offsetLeft) rightmost = row[i];
        }
        rightmost.classList.add('mega-menu__column--row-end');
      });
    }

    requestPositionUpdate() {
      if (this.rafId !== null) return;
      this.rafId = window.requestAnimationFrame(() => {
        this.rafId = null;
        this.updatePosition();
        this.markRowEnds();
      });
    }

    /**
     * Anchor the panel to the exact bottom edge of the shop bar so there is no
     * gap regardless of the announcement bar / sticky header offset.
     */
    updatePosition() {
      const anchor = this.anchor;
      if (!anchor) return;

      const bottom = Math.max(0, Math.round(anchor.getBoundingClientRect().bottom));
      const top = `${bottom}px`;

      this.menu.style.setProperty('--mega-menu-top', top);
      this.overlay.style.setProperty('--mega-menu-top', top);
    }

    handleTriggerClick(e, trigger) {
      if (window.innerWidth < 1025) return;

      if (this.isOpen && this.activeTrigger === trigger) {
        e.preventDefault();
        this.close();
        return;
      }

      e.preventDefault();
      const handle = trigger.getAttribute('data-mega-menu-trigger');
      this.open(handle, trigger);
    }

    open(handle, trigger) {
      this.updatePosition();
      this.splitLongColumns();

      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.getAttribute('data-mega-panel') === handle);
      });

      requestAnimationFrame(() => {
        this.markRowEnds();
        if (this.hasWrapping()) {
          this.splitLongColumns(8);
          requestAnimationFrame(() => {
            this.splitWrappedColumns();
            requestAnimationFrame(() => this.markRowEnds());
          });
        }
      });

      this.triggers.forEach((t) => t.classList.remove('is-active'));
      if (trigger) {
        trigger.classList.add('is-active');
        this.activeTrigger = trigger;
      }

      this.menu.classList.add('is-open');
      this.overlay.classList.add('is-visible');
      this.isOpen = true;
    }

    close() {
      this.menu.classList.remove('is-open');
      this.overlay.classList.remove('is-visible');
      this.isOpen = false;

      if (this.activeTrigger) {
        this.activeTrigger.classList.remove('is-active');
        this.activeTrigger = null;
      }

      this.panels.forEach((panel) => panel.classList.remove('is-active'));
    }
  }

  function initMegaMenu() {
    window.megaMenu = new MegaMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
})();
